import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'  // 引入的变量名是 ElementUI
import 'element-theme-chalk';
import 'element-ui/lib/theme-chalk/index.css';

// import 'element-theme-chalk';
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'

import i18n from './i18n/i18n';
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import axios from 'axios'
import Qs from 'qs'
import routes from './routes'
//import Mock from './mock'
//Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)//富文本  像textarea 可以插图片

// 正确注册 ElementUI，并配置 i18n
Vue.use(ElementUI, {  // 这里用正确的变量名 ElementUI
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueRouter)
Vue.use(Vuex)
import WebSocketClient from './utils/WebSocket';

Vue.config.productionTip = false;
//const wsUrl = 'wss://api.unishow.live/liveWebSocket'; //线上
const wsUrl = 'wss://test.unishow.live/prod-api/liveWebSocket'; //测试
const wsClient = new WebSocketClient(wsUrl);

// 将 WebSocket 实例挂载到 Vue 原型上，方便全局访问
Vue.prototype.$ws = wsClient;
//NProgress.configure({ showSpinner: false });
//线上
axios.defaults.baseURL = 'http://120.55.74.21:8840/' 

Vue.prototype.$http= axios
Vue.prototype.qs = Qs//把参数格式化

const router = new VueRouter({
  routes
})
// router.beforeEach((to, from, next) => {
//   if (to.path == '/login') {}
//   let user = JSON.parse(sessionStorage.getItem('user'));
//   if (!user && to.path != '/login') {
//     next({ path: '/login' })
//   } else {
//     next()
//   }
// })
router.beforeEach((to, from, next) => {
  if (to.path == '/shouye') {}
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/shouye') {
    next({ path: '/shouye' })
  } else {
    next()
  }
})
new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  i18n,
  //components: { App }
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js